module.exports = __webpack_public_path__ + "static/img/1.f2fa283.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/4/1.png
// module id = 240
// module chunks = 0